<template>
  <div>
    <v-layout justify-center>
      <template v-for="(item, i) in paginationItems">
        <v-btn
          v-if="item.page"
          :key="i"
          :color="page == item.page ? 'primary' : null"
          small
          fab
          @click="page == item.page ? null : go(item.page)"
        >
          {{ item.page }}
        </v-btn>
        <span
          v-else
          :key="i"
          class="paginated-table-pagination__ellipse text--primary"
        >{{ item.symbol }}</span>
      </template>
      <v-btn
        small
        color="primary"
        fab
        :disabled="disable"
        @click="go(pages + 1)"
      >
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
function getPaginationArray (current, max) {
  const pagItem = function (page, symbol) {
    return { page, symbol }
  }
  const pagination = []
  if (max == 1)
    pagination.push(pagItem(1))
  else if (max >= 2 && max <= 5)
    for (var i = 1; i <= max; ++i) pagination.push(pagItem(i))
  else if (max > 5)
    if (current <= 3) {
      for (var i = 1; i <= current + 2; ++i) pagination.push(pagItem(i))
      pagination.push(pagItem(null, '...'))
      pagination.push(pagItem(max))
    } else if (current >= max - 2) {
      pagination.push(pagItem(1))
      pagination.push(pagItem(null, '...'))
      for (var i = current - 2; i <= max; ++i) pagination.push(pagItem(i))
    } else {
      pagination.push(pagItem(1))
      pagination.push(pagItem(null, '...'))
      for (var i = current - 2; i <= current + 2; ++i)
        pagination.push(pagItem(i))
      pagination.push(pagItem(null, '...'))
      pagination.push(pagItem(max))
    }

  return pagination
}

export default {
  data () {
    return {
      page: 1,
      pages: 1,
      disable: false
    }
  },
  computed: {
    paginationItems () {
      return getPaginationArray(this.page, this.pages)
    }
  },
  methods: {
    go (page) {
      this.page = page
      this.$emit('go', page)
    },
    restrictNumberOfPages (pages) {
      this.pages = Math.min(this.pages, pages)
    },
    addPage () {
      this.pages++
    },
    reset () {
      this.page = 1
      this.pages = 1
      this.disable = false
    },
    canLoadMore (value) {
      this.disable = !value
    },
    onPageEmpty () {
      if (this.page == 1) {} else {
        const newPage = this.page - 1
        this.pages = this.page = newPage
        this.$emit('go', newPage)
      }
    },
    onPageFilled () {
      this.pages = Math.max(this.page, this.pages)
    }
  }
}
</script>

<style lang="scss" scoped>
.paginated-table-pagination__ellipse {
  display: inline-flex;
  align-items: center;
  margin-left: 12px;
  margin-right: 8px;
}
</style>
